import { IDefineCommand, ICommand } from 'core-ts-types';
import { URLQueryModel } from '../queries/url_query_model';
angular
  .module('data-ng-authentication')
  .factory(
    'loginCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      ngURLQueryModel: URLQueryModel,
      loadAccountCommand: ICommand
    ) =>
      defineCommand('loginCommand', (deferred, credentials) => {
        $http
          .post(ngURLQueryModel.getLoginUrl(), credentials)
          .then((response: ng.IHttpPromiseCallbackArg<any>) => {
            return deferred.resolve(loadAccountCommand());
          })
          .catch((response: ng.IHttpPromiseCallbackArg<any>) => {
            return deferred.reject({
              reason: response.data.display_message || response.data.detail
            });
          });
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/commands/login_command.ts